<form [formGroup]="dynamicForm" autocomplete="off" #formElement (ngSubmit)="onSubmit()">
  <div [ngClass]="border ? 'border rounded-3 p-3 pb-4' : ''">
    <div class="row row-cols-1 g-4" [ngClass]="rowClass">
      <ng-container *ngFor="let field of sortedFields">
        <div [class]="rowClass ? 'col' : field.class">
          <ng-container [ngSwitch]="field.type">
            <div *ngSwitchCase="typeFieldEnum.Input">
              <label [for]="field.name">{{ field.label }}</label>
              <input nz-input [id]="field.name" [formControlName]="field.name" nzSize="large"
                [placeholder]="field.placeholder || field.label" />
            </div>

            <div *ngSwitchCase="typeFieldEnum.Select">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-select [id]="field.name" [nzSize]="'large'" [nzPlaceHolder]="'-'" nzAllowClear nzShowSearch
                [formControlName]="field.name">
                <nz-option [nzValue]="getOptionValue(item, field?.optionValueFn)" [nzLabel]="getOptionLabel(item, field?.optionLabelFn)"
                  *ngFor="let item of getFieldList(field.name)"></nz-option>
              </nz-select>
            </div>

            <div *ngSwitchCase="typeFieldEnum.DatePicker">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-date-picker [id]="field.name" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'" [nzPlaceHolder]="field.placeholder || field.label" [formControlName]="field.name" [nzAllowClear]="true"></nz-date-picker>
            </div>

            <div *ngSwitchCase="typeFieldEnum.TextArea && field.dentroForm">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-textarea-count [nzMaxCharacterCount]="2000">
                <textarea nz-input [id]="field.name" [maxlength]="2000" rows="4" [formControlName]="field.name"
                  [placeholder]="field.placeholder || field.label"></textarea>
              </nz-textarea-count>
            </div>
          </ng-container>
        </div>

        <div class="col-12 col-sm-8 d-flex justify-content-end align-items-end" *ngIf="isCena">
          <button nz-button nzType="primary" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 btn-secondary-color me-2" (click)="selecionarTodos()">
            Selecionar Todos
            <span class="fs-4 ms-2 icon-park-outline--list fw-normal"></span>
          </button>
          <button nz-button nzType="primary" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 btn-secondary-color me-2" (click)="reaproveitar()">
            Reaproveitar
            <span class="fs-4 ms-2 system-uicons--reuse fw-normal"></span>
          </button>
          <button nz-button nzType="default" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 me-2" (click)="cadastrarNovo()">
            Cadastrar Novo
            <span class="fs-4 ms-2 icons8--plus fw-normal"></span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="row mt-2">
    <ng-container *ngFor="let field of sortedFields">
        <ng-container [ngSwitch]="field.type">
          <div *ngSwitchCase="typeFieldEnum.TextArea">
            <div [ngClass]="field.class ? field.class : 'col'">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-textarea-count [nzMaxCharacterCount]="2000">
                <textarea nz-input [id]="field.name" [maxlength]="2000" rows="4" [formControlName]="field.name"
                  [placeholder]="field.placeholder || field.label"></textarea>
              </nz-textarea-count>
            </div>
          </div>
        </ng-container>
    </ng-container>
  </div>
  <div class="col" *ngIf="!isCena">
    <ng-container [ngSwitch]="formType">
      <div *ngSwitchCase="formTypeEnum.Filter">
        <div class="row d-flex justify-content-end mt-4">
          <div class="col-2">
            <button nz-button nzType="default" type="button" nzSize="large"
              class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="reset()">
              Limpar filtro
              <span class="fs-3 ms-2 mdi--garbage-can-outline"></span>
            </button>
          </div>
          <div class="col-3 pe-1">
            <button nz-button nzType="primary" type="submit" nzSize="large"
              class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6">
              Buscar
              <span class="fs-3 ms-2 mdi--search"></span>
            </button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="formTypeEnum.Submit">
        <div class="row d-flex justify-content-end mt-4">
          <div class="col-2">
            <button nz-button nzType="default" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="back()">
              Cancelar
              <span class="fs-4 ms-2 carbon--arrow-left fw-normal"></span>
            </button>
          </div>
          <div class="col-3 pe-1">
            <button nz-button nzType="primary" type="submit" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" >
              <!-- [ngClass]="acao == routeActionEnum.Inserir ? '' : 'btn-primary-color'" -->
              {{ acao == routeActionEnum.Inserir ? 'Cadastrar' : 'Adicionar' }}
              <span class="fs-4 ms-2" ></span>
              <!-- [ngClass]="acao == routeActionEnum.Inserir ? 'material-symbols-light--select-window' : 'gg--check-o'" -->
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</form>
